module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "_Слой_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 85 85"
    }
  }, [_c('g', {
    attrs: {
      "id": "_Слой_1-2"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-2",
    attrs: {
      "cx": "42.5",
      "cy": "42.5",
      "r": "42.5"
    }
  }), _c('g', [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M35.21,63.93c.3-1.7,.57-3.49,.93-5.26,.19-.9,.01-1.55-.69-2.18-1.27-1.13-2.45-2.35-3.67-3.53-.36-.35-.71-.72-.51-1.28,.18-.51,.65-.51,1.09-.57,1.08-.16,2.17-.48,3.25-.45,2.46,.07,3.77-1.17,4.52-3.37,.33-.98,.87-1.89,1.36-2.8,.67-1.24,1.27-1.26,1.92-.03,.77,1.45,1.55,2.9,2.17,4.42,.44,1.08,1.16,1.46,2.23,1.57,1.58,.17,3.15,.44,4.72,.66,.44,.06,.91,.07,1.11,.55,.22,.55-.11,.94-.48,1.29-1.22,1.18-2.41,2.39-3.67,3.53-.69,.62-.91,1.25-.72,2.17,.35,1.66,.64,3.33,.87,5.02,.2,1.45-.24,1.75-1.54,1.14-.5-.23-1.02-.44-1.44-.78-2.8-2.19-5.56-2.25-8.37-.01-.5,.4-1.15,.62-1.74,.91-.94,.45-1.32,.04-1.34-.98Zm7.24-17.69c-.8,1.62-1.48,2.87-2.05,4.16-.39,.89-.95,1.32-1.95,1.46-1.46,.21-2.98,.21-4.49,.83,1.07,1.08,1.98,2.1,3,3,.83,.73,1.09,1.49,.88,2.6-.26,1.39-.72,2.78-.56,4.41,1.37-.72,2.61-1.28,3.76-2,1.02-.63,1.87-.56,2.87,.03,1.18,.7,2.37,1.42,3.88,1.86-.27-1.64-.46-3.1-.76-4.53-.19-.91,.04-1.54,.72-2.18,1.08-1.02,2.28-1.96,3.21-3.36-1.43-.21-2.66-.46-3.9-.55-1.4-.1-2.3-.65-2.79-2.04-.41-1.16-1.09-2.23-1.83-3.68Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M52.12,26.34c-.09,5.41-4.48,9.66-9.86,9.55-5.3-.11-9.51-4.47-9.45-9.79,.06-5.4,4.41-9.6,9.86-9.52,5.31,.08,9.54,4.46,9.45,9.76Zm-17.67-.21c-.03,4.45,3.5,8.08,7.93,8.14,4.4,.06,8.05-3.54,8.1-7.97,.04-4.45-3.51-8.09-7.93-8.12-4.45-.03-8.07,3.52-8.1,7.96Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M57.03,56.23c.09-.48,.11-1,.27-1.45,.84-2.28,.13-4-1.8-5.33-.36-.25-.66-.58-.94-.91-.73-.85-.43-1.61,.57-1.58,3.43,.12,5.44-1.46,6.48-4.67,.38-1.17,1.4-.95,1.72,.09,.98,3.19,3,4.67,6.35,4.58,1.12-.03,1.51,.93,.55,1.62-2.66,1.92-3.59,4.23-2.5,7.43,.41,1.21-.41,1.8-1.42,1.04-2.7-2.04-5.18-1.89-7.83,.06-.87,.64-1.47,.16-1.45-.87Zm8.82-1.3c-1.03-2.81-.24-4.84,2.13-6.58-3.04,.2-4.7-1.29-5.67-4.08-.49,3.32-2.73,3.96-5.47,4.2,2.58,1.58,3.12,3.69,2.12,6.56,2.32-1.96,4.5-1.94,6.89-.11Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M17.11,56.32c.05-.41,.03-.76,.15-1.06,1.01-2.62,.23-4.61-2.03-6.16-.5-.34-1.21-.78-.93-1.57,.27-.78,1.07-.6,1.7-.71,.05,0,.11-.02,.16-.02,2.6,.07,4.32-1.03,5.04-3.63,.17-.61,.37-1.53,1.25-1.56,1.01-.04,1.18,.97,1.37,1.62,.74,2.63,2.52,3.59,5.09,3.59,.67,0,1.57-.1,1.82,.77,.23,.76-.49,1.21-1,1.55-2.32,1.55-2.9,3.6-2.02,6.19,.2,.59,.54,1.33-.11,1.83-.66,.51-1.31,0-1.78-.39-2.39-1.93-4.64-1.47-6.93,.17-.79,.56-1.68,.8-1.76-.62Zm5.37-11.98c-.71,3.05-2.73,3.98-5.47,3.92,.71,1.34,2.18,1.8,2.38,2.97,.2,1.12-.17,2.34-.31,3.66,1.23-.55,2.28-1.28,3.4-1.44,1.2-.17,2.09,1.21,3.68,1.36-1.35-2.73-.49-4.74,1.89-6.44-2.91,.02-4.82-1.08-5.58-4.04Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M42.42,40.98c-1.71,.01-3.43-.15-4.97-.88-1.28-.61-2.38-.44-3.59,.04-1.85,.74-3.56,1.67-5,3.06-.4,.38-.83,.85-1.4,.32-.64-.6-.15-1.1,.29-1.52,2.19-2.1,4.85-3.31,7.76-4.06,.64-.16,1.17,.11,1.73,.34,3.51,1.47,7.02,1.45,10.52-.02,.45-.19,.89-.47,1.4-.36,3.1,.7,5.9,1.98,8.17,4.26,.37,.38,.64,.81,.2,1.28-.53,.57-.99,.2-1.4-.2-1.68-1.64-3.71-2.66-5.91-3.41-.77-.26-1.44-.29-2.2,.05-1.77,.79-3.66,1.09-5.59,1.08Z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c94b65","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/dashboard/kompetentsiy.vue
// module id = ae1e58254521c0142ed2
// module chunks = 89